import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=060363fd&scoped=true&"
import script from "./FormView.vue?vue&type=script&lang=ts&"
export * from "./FormView.vue?vue&type=script&lang=ts&"
import style0 from "./FormView.vue?vue&type=style&index=0&id=060363fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060363fd",
  null
  
)

export default component.exports